// extracted by mini-css-extract-plugin
export var item = "carousel-module--item--br-yq";
export var root = "carousel-module--root--ceTxB";
export var wrapper = "carousel-module--wrapper--f2Cql";